// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_BASE || 'https://qorenova-backend-production.up.railway.app';
export const API_URL = `${API_BASE_URL}/api`;
export const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || API_BASE_URL;

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  // Remove leading slash if present
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

export default {
  API_BASE_URL,
  API_URL,
  SOCKET_URL,
  buildApiUrl,
};
